export const IMPORT_SOURCES = [
  { id: "1password", label: "1Password", steps: "In 1Password: File → Export → choose your account → CSV." },
  { id: "bitwarden", label: "Bitwarden", steps: "In Bitwarden web vault: Tools → Export vault → File format: .csv." },
  { id: "lastpass", label: "LastPass", steps: "In LastPass: Advanced Options → Export → LastPass CSV File." },
  { id: "chrome", label: "Chrome", steps: "In Chrome: Settings → Passwords (Google Password Manager) → Settings → Export passwords." },
];

// Header variants across 1Password, Bitwarden, LastPass and Chrome exports.
export const HEADER_MAP = {
  title: ["title", "name", "item name"],
  url: ["url", "urls", "website", "web site", "uri", "login_uri", "login uri"],
  username: ["username", "user name", "login_username", "login username", "login", "email", "e-mail"],
  password: ["password", "login_password", "login password"],
  notes: ["notes", "note", "comments", "extra"],
  tags: ["tags", "tag", "grouping", "folder", "category"],
  favorite: ["favorite", "fav", "favourite"],
  kind: ["type"],
};

export const isTruthy = (v) => ["1", "true", "yes", "y"].includes(String(v || "").trim().toLowerCase());
